








































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import GrpTargetEditor from "@/components/GrpTargetEditor.vue";
import GrpTargetCreate from "@/components/GrpTargets/Create.vue";
import { Target } from "@/models";

const DEFAULT_PLACEHOLDER = "Selezionare un target";

@Component({
  components: {
    GrpTargetEditor,
    GrpTargetCreate,
  },
})
export default class GrpTargetSelect extends Vue {
  @Prop() readonly value!: Target | null;
  @Prop({ default: DEFAULT_PLACEHOLDER }) readonly placeholder!: string;
  @Prop({ default: true }) readonly selectLast!: boolean;
  @Ref() readonly grpCreate!: GrpTargetCreate;
  @Ref() readonly editor!: GrpTargetEditor;
  @Prop({ default: false }) readonly openLeft!: boolean;

  visible = false;
  enabled = false;
  isCreating = false;

  selected: Target | null = null;

  get label(): string {
    if (this.selected == null) {
      return this.placeholder || DEFAULT_PLACEHOLDER;
    }

    return this.selected.name;
  }

  get componentClass() {
    return {
      "grp-target-editor--disabled": this.enabled == false,
    };
  }

  async onCreate() {
    this.isCreating = true;
    await this.$nextTick();
    this.grpCreate.init();
  }

  created() {
    this.selected = this.value?.clone();
  }

  toggleDropdown() {
    if (this.enabled === false) {
      return;
    }

    this.visible = !this.visible;
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
      this.isCreating = false;
    }
  }

  onCancel() {
    this.closeDropdown();
  }

  emitValue() {
    this.$emit("input", this.selected?.clone());
  }

  onReady() {
    this.enabled = true;

    if (this.selected) {
      (this.$refs.editor as GrpTargetEditor).selectById(this.selected.id);
    } else if (this.selectLast) {
      const target = localStorage.getItem(`${this.$options.name}-target`);

      if (target) {
        (this.$refs.editor as GrpTargetEditor).selectById(target);
      }

      if (!this.selected) {
        (this.$refs.editor as GrpTargetEditor).selectFirst();
      }
    } else {
      (this.$refs.editor as GrpTargetEditor).selectFirst();
    }

    this.$emit("ready");
  }

  onSelected(target: Target) {
    this.selected = target;
    this.emitValue();

    localStorage.setItem(`${this.$options.name}-target`, target.id);
  }

  onClickOutside() {
    this.isCreating = false;
  }

  async onSave(target: Target) {
    this.isCreating = false;
    await this.$nextTick();
    this.editor.load();
    this.onSelected(target);
  }
}
